var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',[_c('nav',[_c('ul',[_c('li',{staticClass:"masthead"},[_c('router-link',{attrs:{"to":{
              name: 'home'
            }}},[(_vm.brandings.brand_name)?_c('span',[_vm._v("\n              "+_vm._s(_vm.brandings.brand_name)+" Admin\n            ")]):_vm._e()])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10166a7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1132
// module chunks = 1